
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ConvivaApi } from "src/app/conviva-api";
import { DefaultResponse } from "src/app/shared/models/DefaultResponse";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { CriarFatosAlunos } from "../models/CriarFatosAlunos";


@Injectable({
  providedIn: 'root',
})
export class FatosService {
  private api = ConvivaApi;

  constructor(
    private http: HttpClient,
    private convivaErrorsHandler: ConvivaErrorHandlingService) { }

  public getDashboard(
    codigoDiretoria: number,
    codigoEscola: number,
    anoAtual: number,
    codigoTurma?: number | null,
    codigoTurno?: number | null
  ): Observable<DefaultResponse> {
    const params: Record<string, number> = {
      cdDiretoria: codigoDiretoria,
      cdEscola: codigoEscola,
      anoLetivo: anoAtual,
      cdTurno: codigoTurno ?? 0,
    };

    if (codigoTurma) {
      params['cdTurma'] = codigoTurma;
    }

    return this.http.get<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.getDashboard, { params })
      .pipe(map((response: DefaultResponse) => response));
  }
  public getFatosAlunos(): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.Agendamento.setCadastrarAgendamento)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getFaixasCreditos(): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.CivicoMilitar.Fatos.getFaixasDeCredito)
      .pipe(map((response: DefaultResponse) => response));
  }

  public setAtualizaFaixaCredito(payload: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.Fatos.setAtualizaFaixaCredito, payload)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getFatos(): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(this.api.CivicoMilitar.Fatos.getFatos)
      .pipe(map((response: DefaultResponse) => response));
  }

  public atualizarFatosNovaResolucao(payload: any): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.Fatos.atualizarFatosNovaResolucao, payload)
      .pipe(map((response: DefaultResponse) => response));
  }


  public criarFatosAlunos(parametros: CriarFatosAlunos): Observable<DefaultResponse> {
    return this.http.post<DefaultResponse>(this.api.CivicoMilitar.FatosAluno.criarFatosAlunos, parametros)
      .pipe(map((response: DefaultResponse) => response));
  }

  public getAlunosPorRa(raAluno: string): Observable<DefaultResponse> {
    return this.http.get<DefaultResponse>(`${this.api.CivicoMilitar.FatosAluno.getAlunoPorRAEEscola}?ra=${raAluno}`)
      .pipe(map((response: DefaultResponse) => response));
  }

}
